/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
  getTheme,
  ILabelStyles,
  IStackItemStyles,
  IStackStyles,
  IStackTokens,
} from "@fluentui/react";

const theme = getTheme();

/**
 * Token for the body stack
 */
export const bodyContainerStackTokens = (): IStackTokens => {
  return { childrenGap: "1rem" };
};

/**
 * Styling for the body row stack
 */
export const bodyRowStackStyles = (): IStackStyles => {
  return { root: { display: "flex", justifyContent: "space-between" } };
};

/**
 * Styling for the body column stack
 */
export const bodyColumnStackItemStyles = (): IStackItemStyles => {
  return { root: { width: "50%" } };
};

/**
 * Styling for the label
 */
export const labelStyles = (): ILabelStyles => {
  return { root: { fontWeight: 600 } };
};

export const spanStyles = {
  color: theme.palette.red,
};
